import { makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import { getAllRestaurantType } from '../../../store/actions/user/User';
import { connect } from 'react-redux';
import Moment from 'moment';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { Divider } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  vendorCard: {
    width: '100%',
    height: '200px',
    display: 'flex',
    padding: '0.5rem',
    alignItems: 'center',
    justifyContent: 'space-around',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: 'rgba(188, 188, 188, 0.5) 0px 2px 9px 0px',
      borderRadius: '16px'
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem'
    }
  },
  vendorDetails: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    cursor: 'pointer',
    height: '70px'
  },
  vendorName: {
    fontSize: '20px',
    fontWeight: 700
  },
  distance: {
    color: '#727272',
    paddingRight: '5px'
  },
  root: {
    display: 'flex',
    cursor: 'pointer',
    borderRadius: '25px',
    height: 'fit-content',
    margin: '3%',
    marginBottom: '5%',
    '&:hover': {
      boxShadow: '0 3px 5px 2px rgba(0,0,0, .4)',
      cursor: 'pointer'
    },
    boxShadow:
      '0px 2px 1px -1px rgba(0,0,0,0), 0px 1px 1px 0px rgba(0,0,0,0), 0px 1px 3px 0px rgba(0,0,0,0)'
  },
  details: {
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'column',
    width: '50%'
  },
  content: {
    flex: '1 0 auto',
    textAlign: 'left'
  },
  cover: {
    width: '50%',
    borderRadius: '10%'
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  gap: {
    margin: '4px 0px 2px'
  }
}));

const VendorCard = ({
  icon,
  name,
  distance,
  latitude1,
  longitude1,
  days,
  city,
  closetime,
  opentime,
  street,
  id,
  restaurantType2,
  restaurantType3,
  shopOpen,
  // superCategoryId,
  ...rest
}) => {
  const classes = useStyles();
  const [deliveryTime, updateDeliveryTime] = useState('0 ');
  const { superCategoryId } = useParams();
  const history = useHistory();
  const redirectToVendor = () => {
    history.push({
      pathname: `/super-category/${superCategoryId}/vendor/${id}/restaurant`,
      state: {
        isRestaurant: rest?.location?.state?.isRestaurant
      }
    });
  };

  // const getDistance = (la1, lon1, la2, lon2) => {
  //   let ApiURL =
  //     'https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&';
  //   let params = `origins=${la1},${lon1}&destinations=${la2},${lon2}&key=AIzaSyBEcPnjKk_2f_8NIHc-mfYKT9ft-CCz_HM`;
  //   let finalApiURL = `${ApiURL}${encodeURI(params)}`;
  //   return fetch(finalApiURL) // return this promise
  //     .then((response) => response.json())
  //     .then((result) =>
  //       updateDeliveryTime(
  //         parseInt(result.rows[0].elements[0].duration.text) + 15
  //       )
  //     )
  //     .catch((error) => console.log('error:', error));
  // };
  // getDistance(lat, lng, latitude1, longitude1);

  const restaurantType = restaurantType2;

  return (
    <Card className={classes.root} onClick={redirectToVendor} style={{ cursor: 'pointer' }}>
      <CardMedia
        className={classes.cover}
        image={
          icon 
        }
        title="vendor"
        style={{ cursor: 'pointer' }}
      />
      <div className={classes.details}>
        <CardContent
          className={classes.content}
          style={{ paddingBottom: '2px', paddingTop: '0' }}
        >
          <b style={{ textTransform: 'capitalize', fontWeight: 700 }}>{name}</b>
          <p
            style={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              fontWeight: 600,
              textTransform: 'capitalize',
              marginBottom: '0',
              color: '#000'
            }}
          >
            <span>
              {restaurantType.length !== 0
                ? restaurantType
                  .filter(
                    (categorieFilter) =>
                      restaurantType3 && Array.isArray(restaurantType3) && categorieFilter.id === restaurantType3[0]
                  )
                  .map((item, index) => <span>{item.name} </span>)
                : ''}{' '}
            </span>
          </p>
          <p
            style={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              color: '#000',
              fontWeight: 600,
              marginBottom: '0',
              marginTop: '0.751rem'
            }}
          >
            {street}
          </p>
          <p
            style={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              color: '#000',
              fontWeight: 600,
              textTransform: 'capitalize',
              marginBottom: '0',
              marginTop: '0',
              paddingTop: '0'
            }}
          >
            {rest?.duration?.text}
          </p>
          <Divider />
          <div className="container mb-1">
            <div className="row">
              <div
                className="col-6"
                style={{ textAlign: 'initial', paddingRight: '5px' }}
              >
                <small
                  style={{
                    color: shopOpen ? '#03913F' : 'red',
                    fontWeight: 700,
                    marginLeft: '-15px',
                    paddingLeft: '0px'
                  }}
                  className={classes.gap}
                >
                  {shopOpen ? 'Open' : 'Closed'}
                </small>
              </div>
              <div
                className="col-6"
                style={{ textAlign: 'right', padding: '0' }}
              >
                <small color="textSecondary">
                  {(distance / 1000).toFixed(2)}KM
                </small>
              </div>
            </div>
          </div>
        </CardContent>
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  restaurantType: state.user.restaurantType
});
const mapDispatchToProps = (dispatch) => ({
  getAllRestaurantType: (superCategory) =>
    dispatch(getAllRestaurantType(superCategory))
});

export default connect(mapStateToProps, mapDispatchToProps)(VendorCard);
